module.exports = __webpack_public_path__ + "static/media/scans_0007.af4c39d7.jpg";